<script>
    import { push } from "svelte-spa-router";
    import { countryStore } from "../store/countries.js";
    import { factoryStore } from "../store/factories.js";
    import { calculatorStore } from "../store/Calculators.js";
    import { langTextStore } from "../store/langtexts.js";
    import IconBack from "../Vectors/back.svelte";
    import { fade, fly } from "svelte/transition";
    import { cubicOut, cubicIn, sineOut } from "svelte/easing";
    export let virginUser = false;
    import { getContext } from "svelte";

    const { snackbar } = getContext("app");

    let errormessage = "";
    let factory = {
        name: "",
        countryId: null,
        firstVersionName: "",
    };
    let showFactoryCreatedMessage = false;
    let factorySettingsId = null;
    countryStore.getCountries();
    let saving = false;
    $langTextStore.getText("general-label-choose-a-country-first");
    $langTextStore.getText("general-label-choose-a-name-for-version-first");
    async function save() {
        if (!(factory.countryId > 0)) {
            snackbar(
                "info",
                $langTextStore.getText("general-label-choose-a-country-first")
            );
            return;
        }
        if (factory.firstVersionName.length == 0) {
            snackbar(
                "info",
                $langTextStore.getText(
                    "general-label-choose-a-name-for-version-first"
                )
            );
            return;
        }
        var country = $countryStore.find((c) => c.id == factory.countryId);
        var factoryId = await factoryStore.saveFactory({
            name: factory.name,
            countryId: factory.countryId,
        });

        saving = true;
        var version = await calculatorStore.getCalculator(country.version.id);
        var allVars = version.variables;
        for (var theVar in allVars) {
            try {
                if (!isNaN(allVars[theVar].formula)) {
                    allVars[theVar].formula = parseFloat(
                        allVars[theVar].formula
                    );
                }
            } catch (s) {
                debugger;
            } //wont work for formulas, but this makes the input ones numbers instead of string so 4 + 5 = 9 instead "4" + "5" == "45"
        }
        var scenarios = [];
        scenarios.push("target-wage");
        scenarios.push("alternate");
        var scenarioVars = [];
        scenarioVars.push("Wage");

        var scenarioVarValues = {};
        scenarioVarValues["target-wage"] = {};
        scenarioVarValues["alternate"] = {};
        scenarioVarValues["target-wage"]["Wage"] = allVars.filter(
            (v) => v.varNameKey == "TargetWage"
        )[0].formula;
        factorySettingsId = await factoryStore.saveFactoryOrProductSettings({
            name: factory.firstVersionName,
            countryVersionId: country.version.id,
            country: country.nameKey,
            availableLangs: version.availableLangs,
            alternateCurrencyId: version.currencyId,
            currencyId: version.currencyId,
            excelSheetNames: version.excelSheetNames,
            factoryId: factoryId,
            year: new Date().getFullYear(),
            month: new Date().getMonth(),
            variables: allVars,
            subSections: version.subSections,
            scenarioConfiguration: {
                scenarios: scenarios,
                scenarioVars: scenarioVars,
                scenarioVarValues: scenarioVarValues,
            },
        });
        if (virginUser) {
            showFactoryCreatedMessage = true;
        } else {
            push("#/calculator/factorysettings/" + factorySettingsId);
        }
    }
    function init(element) {
        element.focus();
    }

    function cancel() {
        push("#/dashboard/factories");
    }
    var hasFactories = false;
    async function startPage() {
        hasFactories = await factoryStore.hasFactories();
    }
    startPage();
</script>

<button class="back-to-dash" on:click={cancel}>
    <IconBack />
    {$langTextStore.getText("general-label-exit")}
</button>

<div
    class="container align-vertical-middle"
    in:fly={{ y: 250, duration: 1600, easing: sineOut }}
    out:fade={{ duration: 200 }}
>
    <div class="row" in:fade={{ delay: 800 }}>
        <div class="col-12 offset-md-3 col-md-6 bg-gray-8 p-4  box-shadow">
            <div class="innner_modal ">
                {#if saving}
                    <h2 class="gray-6 text-center mt-3 mb-5">
                        preparing calculator....
                    </h2>
                {:else if !showFactoryCreatedMessage}
                    {#if virginUser}
                        <h2 class="gray-6 text-center mt-3 mb-5">
                            {$langTextStore.getText(
                                "general-text-lets-get-started"
                            )}
                        </h2>
                    {:else}
                        <h2 class="gray-6 text-center mt-3 mb-5">
                            {$langTextStore.getText("general-text-lets-setup")}
                        </h2>
                    {/if}
                    <div class="mt-1">
                        <label for="fixedId"
                            >{$langTextStore.getText(
                                "general-label-factory-name"
                            )}
                        </label>
                        <input
                            use:init
                            bind:value={factory.name}
                            id="fixedId"
                            type="text"
                            class="form-control"
                            placeholder={$langTextStore.getText(
                                "general-label-factory-name"
                            )}
                        />
                    </div>
                    <div class="mt-1">
                        <label for="versionname"
                            >{$langTextStore.getText(
                                "general-label-factory-version-name"
                            )}
                        </label>
                        <input
                            bind:value={factory.firstVersionName}
                            id="versionname"
                            type="text"
                            class="form-control"
                            placeholder={$langTextStore.getText(
                                "general-label-factory-version-name"
                            )}
                        />
                    </div>
                    <div class="mt-1">
                        <label for="fixedId"
                            >{$langTextStore.getText("general-label-country")}
                        </label>
                        <select
                            bind:value={factory.countryId}
                            class="form-control mb-3"
                            placeholder="asd"
                        >
                            <option
                                >{$langTextStore.getText(
                                    "general-label-choose-a-country"
                                )}</option
                            >
                            {#each $countryStore as country}
                                <option value={country.id}
                                    >{country.nameKey}
                                </option>
                            {/each}
                        </select>
                    </div>
                    <div class="w-100 text-right">
                        {#if hasFactories}
                            <button
                                type="button"
                                class="btn btn-gray width-unset "
                                on:click={cancel}
                                >{$langTextStore.getText(
                                    "general-label-cancel"
                                )}</button
                            >
                        {/if}
                        <button
                            type="button"
                            class="btn btn-primary width-unset ms-2 mt-3 mb-0"
                            on:click={save}
                            >{$langTextStore.getText(
                                "general-label-next"
                            )}</button
                        >
                    </div>
                {:else}
                    <h2>
                        <span class="highlight"
                            >{$langTextStore.getText(
                                "general-text-congratulations"
                            )}</span
                        >
                        {$langTextStore.getText(
                            "general-text-you-just-created-factory"
                        )}
                    </h2>
                    <p>
                        {$langTextStore.getText(
                            "general-text-you-can-keep-several-versions-lets-setup-first-one-now"
                        )}
                    </p>
                    <p>
                        <a
                            href="#/calculator/factorysettings/{factorySettingsId}"
                            class="btn btn-primary"
                            >{$langTextStore.getText(
                                "general-label-get-started"
                            )}</a
                        >
                    </p>
                {/if}
            </div>
        </div>
    </div>
</div>
